<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.93,14.67C13.93,14.67,13.93,14.67,13.93,14.67C13.93,14.67,8.940000000000001,0.67,8.940000000000001,0.67C8.940000000000001,0.67,8.93,0.67,8.93,0.67C8.79,0.28,8.43,0,8,0C7.57,0,7.21,0.28,7.07,0.67C7.07,0.67,7.06,0.67,7.06,0.67C7.06,0.67,2.06,14.67,2.06,14.67C2.06,14.67,2.07,14.67,2.07,14.67C2.03,14.77,2,14.88,2,15C2,15.55,2.45,16,3,16C3.4299999999999997,16,3.79,15.72,3.9299999999999997,15.33C3.9299999999999997,15.33,3.94,15.33,3.94,15.33C3.94,15.33,5.49,11,5.49,11C5.49,11,10.51,11,10.51,11C10.51,11,12.06,15.34,12.06,15.34C12.06,15.34,12.07,15.34,12.07,15.34C12.21,15.72,12.57,16,13,16C13.55,16,14,15.55,14,15C14,14.88,13.97,14.77,13.93,14.67C13.93,14.67,13.93,14.67,13.93,14.67ZM6.2,9C6.2,9,8,3.97,8,3.97C8,3.97,9.8,9,9.8,9C9.8,9,6.2,9,6.2,9C6.2,9,6.2,9,6.2,9Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Font',
} as DefineComponent
</script>
